import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig.js";

export default function Sitemap() {
  useSEO(seoConfig.sitemap);

  return (
    <section className="contacts science">
      <Breadcrumbs />

      <h1 className="contacts__title history__title">Карта сайта</h1>

      <div className="sitemap__list">
        <Link to="/about" className="sitemap__link">
          Об институте
        </Link>
        <div className="sitemap__section">
          <Link to="/about/history" className="sitemap__content">
            История института
          </Link>
          <Link to="/about/structure" className="sitemap__content">
            Структура института
          </Link>
          <Link to="/about/managers" className="sitemap__content">
            Руководители
          </Link>
          <Link to="/about/licenses" className="sitemap__content">
            Правовая информация и лицензии
          </Link>
          <Link to="/about/privacy" className="sitemap__content">
            Политика конфиденциальности
          </Link>
          <Link to="/about/anti-corruption" className="sitemap__content">
            Противодействие коррупции
          </Link>
          <Link to="/about/anti-terror" className="sitemap__content">
            Антитеррористическая безопасность
          </Link>
          <Link to="/about/controls" className="sitemap__content">
            Органы управления
          </Link>
          <Link to="/about/vacancies" className="sitemap__content">
            Вакансии
          </Link>
          <Link to="/about/news" className="sitemap__content">
            Новости
          </Link>
          <Link to="/about/sitemap" className="sitemap__content">
            Карта сайта
          </Link>
          <Link to="/about/working-conditions" className="sitemap__content">
            Условия труда
          </Link>
          <Link to="/about/accounting-policy" className="sitemap__content">
            Учетная политика
          </Link>
          <Link to="/about/independent-assessment" className="sitemap__content">
            Независимая оценка качества
          </Link>
          <Link to="/about/heating-season" className="sitemap__content">
            Подготовка к отопительному сезону
          </Link>
        </div>

        <Link to="/science" className="sitemap__link">
          Наука
        </Link>
        <div className="sitemap__section">
          <Link to="/science/research" className="sitemap__content">
            Научно-исследовательские разработки
          </Link>
          <Link to="/science/development" className="sitemap__content">
            Разработка медицинских и организационных технологий
          </Link>
          <Link to="/science/dissertation" className="sitemap__content">
            Диссертационный совет
          </Link>
          <div className="sitemap__block">
            <Link
              to="/science/dissertation/videobroadcast"
              className="sitemap__content"
            >
              Видеотрансляции
            </Link>
            <Link
              to="/science/dissertation/advertisements"
              className="sitemap__content"
            >
              Объявления о защите кандидатских и докторских диссертаций
            </Link>
          </div>
          <Link to="/science/clinical-trials" className="sitemap__content">
            Клинические испытания лекарственных средств
          </Link>
          <Link to="/science/publications" className="sitemap__content">
            Научные публикации
          </Link>
          <Link to="/science/scientific-research" className="sitemap__content">
            Научные исследования
          </Link>
          <Link to="/science/certification" className="sitemap__content">
            Аттестация научных работников
          </Link>
          <Link to="/science/patents" className="sitemap__content">
            Патенты
          </Link>
          {/* <Link to="/science/assistance" className="sitemap__content">
              Лечебно-диагностическая помощь
            </Link> */}
        </div>

        <Link to="/education" className="sitemap__link">
          Образование
        </Link>
        <div className="">
          <Link to="/education/residency" className="sitemap__content">
            Ординатура
          </Link>
          <div className="sitemap__block">
            <Link
              to="/education/residency/scientific-educational"
              className="sitemap__content"
            >
              Научно - образовательный отдел
            </Link>
            <Link
              to="/education/residency/educational-program"
              className="sitemap__content"
            >
              Образовательная программа ординатуры
            </Link>
            <Link
              to="/education/residency/regulatory-documents"
              className="sitemap__content"
            >
              Нормативные документы
            </Link>
            <Link
              to="/education/residency/organization-monitoring"
              className="sitemap__content"
            >
              Организация мониторинга качества образования
            </Link>
            <Link
              to="/education/residency/clinical-base"
              className="sitemap__content"
            >
              Клиническая база ГБУ СО "УрНИИДВиИ"
            </Link>
            <Link
              to="/education/residency/contingent-students"
              className="sitemap__content"
            >
              Контингент обучающихся в ординатуре: 2018 год
            </Link>
          </div>
          <Link
            to="/education/postgraduate-studies"
            className="sitemap__content"
          >
            Аспирантура
          </Link>
          <Link to="/education/additional" className="sitemap__content">
            Дополнительное профессиональное образование
          </Link>
          <div className="sitemap__block">
            <Link
              to="/education/additional/advanced-training"
              className="sitemap__content"
            >
              Циклы повышения квалификации
            </Link>
            <Link
              to="/education/additional/certification-cycle"
              className="sitemap__content"
            >
              Сертификационный цикл
            </Link>
            <Link
              to="/education/additional/short-improvement"
              className="sitemap__content"
            >
              Краткосрочное тематическое усовершенствование
            </Link>
            <Link
              to="/education/additional/professional-retraining"
              className="sitemap__content"
            >
              Профессиональная переподготовка по специальности "Косметология"
            </Link>
          </div>
          <Link to="/education/teaching-staff" className="sitemap__content">
            Профессорско-преподавательский состав
          </Link>
          <Link
            to="/education/admissions-committee"
            className="sitemap__content"
          >
            Приемная комиссия
          </Link>
          <Link to="/education/tax-deduction" className="sitemap__content">
            Налоговый вычет за платные образовательные услуги
          </Link>
        </div>

        <Link to="/clinic" className="sitemap__link">
          Клиника
        </Link>
        <div className="">
          <Link to="/clinic/hospital" className="sitemap__content">
            Высокотехнологичная медицинская помощь
          </Link>
          <Link to="/clinic/specialized-medical" className="sitemap__content">
            Специализированная медицинская помощь
          </Link>
          {/* <Link to="/clinic/day-hospital" className="sitemap__content">
              Дневной стационар
            </Link> */}
          {/* <Link to="/clinic/consultative" className="sitemap__content">
              Консультативно-диагностическое отделение
            </Link> */}
          {/* <Link to="/clinic/laboratory" className="sitemap__content">
              Лаборатория
            </Link> */}
          <Link to="/clinic/working-chief" className="sitemap__content">
            Работа с главными врачами кожно-венерологических учреждений
          </Link>
          <Link to="/clinic/problem-syphilis" className="sitemap__content">
            Консультативный совет по проблемме сифилис
          </Link>
        </div>

        <Link to="/patients" className="sitemap__link">
          Пациентам
        </Link>
        <div className="">
          <Link to="/patients/reception" className="sitemap__content">
            Прием специалистов
          </Link>
          <Link to="/patients/reception-omc" className="sitemap__content">
            Прием специалистов ОМС
          </Link>
          <Link to="/patients/working" className="sitemap__content">
            График работы
          </Link>
          <Link to="/patients/pay" className="sitemap__content">
            Платные медицинские услуги
          </Link>
          <Link to="/patients/price-list" className="sitemap__content">
            Прейскурант
          </Link>
          <Link to="/patients/specialists" className="sitemap__content">
            Специалисты
          </Link>

          <Link to="/#record" className="sitemap__content">
            Запись на прием
          </Link>

          <Link to="/patients/provision" className="sitemap__content">
            Оказание услуг гражданам в сфере здравоохранения
          </Link>
          <Link to="/patients/participantsSVO" className="sitemap__content">
            Участникам СВО
          </Link>
          <Link
            to="/patients/accessible-environment"
            className="sitemap__content"
          >
            Доступная среда
          </Link>
          <Link to="/patients/helplines" className="sitemap__content">
            Телефоны доверия
          </Link>
          <Link to="/patients/fire-safety" className="sitemap__content">
            Пожарная безопасность
          </Link>
          <Link
            to="/patients/clinical-examination"
            className="sitemap__content"
          >
            Диспансеризация населения
          </Link>
          <Link to="/patients/week" className="sitemap__content">
            Мероприятия по профилактике заболеваний и поддержке здорового образа
            жизни
          </Link>
          <Link to="/patients/gosuslugi" className="sitemap__content">
            Госуслуги
          </Link>
          <Link to="/patients/question-answer" className="sitemap__content">
            Вопрос–ответ
          </Link>
          <Link to="/patients/reviews" className="sitemap__content">
            Отзывы
          </Link>
          <Link to="/patients/emergency-numbers" className="sitemap__content">
            Телефоны справочных служб
          </Link>
        </div>

        <Link to="/contacts" className="sitemap__link">
          Контакты
        </Link>
      </div>
    </section>
  );
}
